import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../services/apiClient";
import { useTheme } from '../config/ThemeContext';

function PlayersRanking() {
  const { seasonId } = useParams();
  const [reportHtml, setReportHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const colors = useTheme();

  useEffect(() => {
    const fetchReport = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get(`/api/seasons/${seasonId}/players-ranking`, {
          responseType: 'text'
        });
        setReportHtml(response.data);
      } catch (err) {
        console.error('Failed to load Players Ranking:', err);
        setError('Failed to load report.');
      } finally {
        setLoading(false);
      }
    };

    if (seasonId) fetchReport();
  }, [seasonId]);

  const handleDownloadPDF = async () => {
    try {
      const response = await apiClient.get(`/api/seasons/${seasonId}/players-ranking/download`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `PlayersRanking_Season_${seasonId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
      alert('Failed to download PDF.');
    }
  };

  if (loading) return <div className="p-8 text-center">Loading Report...</div>;
  if (error) return <div className="p-8 text-red-600">{error}</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6 print:hidden">
        <h1 className={`text-2xl font-bold ${colors.neutral.text}`}>Players Ranking</h1>
        <button onClick={handleDownloadPDF} className={`px-4 py-2 rounded-md ${colors.buttons.primary}`}>
          Download PDF
        </button>
      </div>
      <div className="bg-white rounded-lg shadow-sm border p-6 overflow-auto">
        <div dangerouslySetInnerHTML={{ __html: reportHtml }} />
      </div>
    </div>
  );
}

export default PlayersRanking;